import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/phone_no_bg2.png'
import _imports_1 from '@/assets/android-head_flat.png'


const _hoisted_1 = { class: "select-all" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","height":"70vh"} }
const _hoisted_3 = { style: {"width":"100%","display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = { style: {"font-weight":"bold","margin-left":"8px"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"space-between","width":"100%","align-items":"center","margin-bottom":"4px"} }
const _hoisted_7 = { style: {"color":"#909399"} }
const _hoisted_8 = { style: {"display":"flex","justify-content":"space-between","width":"100%","align-items":"center"} }
const _hoisted_9 = {
  class: "top-right-buttons",
  style: {"margin-bottom":"10px"}
}
const _hoisted_10 = { class: "compact-rectangle" }
const _hoisted_11 = { style: {"display":"flex","flex-direction":"column","height":"100%","width":"100%","position":"relative","padding-bottom":"20px"} }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onUpdate:modelValue", "onBlur", "onKeydown"]
const _hoisted_14 = {
  key: 0,
  style: {"display":"inline-block","width":"72%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  src: _imports_0,
  alt: "Logo",
  style: {"max-width":"100%","max-height":"100%"}
}
const _hoisted_18 = { class: "phone-android-version-view" }
const _hoisted_19 = { class: "compact-image-container" }
const _hoisted_20 = { style: {"display":"flex","flex-direction":"column","align-items":"center","align-content":"center"} }
const _hoisted_21 = { class: "android-tabs-header" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  style: {"margin-top":"10px"},
  class: "flex_between_center"
}
const _hoisted_24 = { style: {"text-align":"left"} }
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = { class: "overlay-mask" }
const _hoisted_27 = { class: "overlay-content" }
const _hoisted_28 = ["readOnly"]
const _hoisted_29 = ["readOnly"]
const _hoisted_30 = ["element-loading-text"]
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "info-container" }
const _hoisted_33 = { class: "info-row" }
const _hoisted_34 = { class: "info-value" }
const _hoisted_35 = { class: "info-row" }
const _hoisted_36 = { class: "info-value" }
const _hoisted_37 = { class: "info-row" }
const _hoisted_38 = { class: "info-value" }
const _hoisted_39 = { class: "info-row" }
const _hoisted_40 = { class: "info-value" }
const _hoisted_41 = { class: "info-row" }
const _hoisted_42 = { class: "info-value" }
const _hoisted_43 = { class: "info-row" }
const _hoisted_44 = { class: "info-value" }
const _hoisted_45 = { class: "info-row" }
const _hoisted_46 = { class: "info-value" }
const _hoisted_47 = { class: "action-row" }

import { useRouter } from 'vue-router';
	import '../style/app.css';
	import defaultImage from '@/assets/phone_no_bg2.png';
	import { ref, Ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
	import { Close, CirclePlus, ArrowRight, ArrowLeft, Edit } from '@element-plus/icons-vue'; // 补充导入 Edit 图标
	import { StreamClientScrcpy } from '@/app/googDevice/client/StreamClientScrcpy';
	import CountdownComponent from '@/components/CountdownComponent.vue';
	import { KeyInputHandler, type KeyEventListener } from '@/app/googDevice/KeyInputHandler';
	import { CommandControlMessage } from '@/app/controlMessage/CommandControlMessage'
	import { ElMessage, ElMessageBox } from 'element-plus';
	import request from '@/utils';
	import { useStore } from 'vuex';
	import type { PopoverInstance } from 'element-plus'
	type Machine = {
		id : number;
		ip : string;
		cpu : string;
		cpu_core : number;
		memory : number;
		volume : number;
		status : number;
		created_at : string;
		updated_at : string;
		mac_addr : string;
		volume_device : string;
	};
	type Real_phone_template = {
		brand : string;
		model : string;
	}
	type Instance = {
		id : number;
		machine_id : number;
		mac : string;
		ip : string;
		product_id : number;
		package_id : number;
		created_at : string;
		updated_at : string;
		status : number;
		is_realphone : number;
		adb_port : number;
		adb_address : string;
		height : number;
		width : number;
		image : string;
		image_tag : string;
		index : number;
		state : number;
		cpu_cores : number;
		memory : number;
		storage : number;
		name : string;
		machine : Machine;
		real_phone_template : Real_phone_template;
	};

	type Phone = {
		id : number;
		user_id : string;
		instance_id : number;
		start_time : string;
		expire_time : string;
		status : number;
		created_at : string;
		updated_at : string;
		order_id : number;
		image : string;
		image_tag : string;
		auto_renew : number;
		screen_shot : string;
		instance_name : string;
		instances : Instance;
		is_trial ?: number;
		state : number;
		checked ?: boolean;
		edit_name_checked ?: boolean;
		preview_image : string;
		screen_shot_loading ?: boolean;
	};

	// 修复点3：定义 PhoneBrand 和 ModelOption 类型，明确结构
	interface ModelOption {
		id : number | string;
		model : string;
		[key : string] : any; // 兼容其他属性
	}

	interface PhoneBrand {
		brand : string;
		models : ModelOption[]; // 明确 models 是 ModelOption 数组
	}
	// 新增：安卓版本分组类型
	interface AndroidVersionGroup {
		android_version : string;
		phones_arr : Phone[];
	}
	interface ApiResponse<T = any> {
		code : number;
		msg : string;
		data : T;
	}
	//获取云手机列表数据
	interface CommitMsg { type : 'commit'; text ?: string; }
	interface DeleteMsg { type : 'delete'; count : number; text ?: string; }
	interface ReplaceMsg { type : 'replace'; text ?: string; }
	type InputMsg = CommitMsg | DeleteMsg | ReplaceMsg;
	
export default /*@__PURE__*/_defineComponent({
  __name: 'MyPhone',
  setup(__props) {

	const router = useRouter();
	const phone_type_popoverRef = ref<PopoverInstance>()
	const store = useStore();
	const elementWidth = ref('auto');
	const elementWidthflag = ref(true);
	const search = ref('');
	const viewMode = ref('card');
	const showOverlay = ref(false);
	const showInfoPanel = ref(true);
	const windowWidth = ref(window.innerWidth);
	const loading = ref(false);
	const restartPhone_loading = ref(false);
	const restartPhone_loading_text = ref('云手机重启中,请稍等');
	const phoneList = ref<Phone[]>([]);
	const previewPhoneList = ref<Phone[]>([]);
	const No_change_phone_list = ref<Phone[]>([]);
	const filter_phone_type_list = ref<Phone[]>([]);
	const Phone_selectedMap = ref(new Map<number, boolean>());
	const Phone_selectedMap_right = ref(new Map<number, boolean>());
	const currentPhone = ref<Phone>({} as Phone);
	const hash = location.hash.replace(/^#!/, '');
	const parsedQuery = new URLSearchParams(hash);
	const selectAllChecked = ref(false);
	const selectAllChecked_right = ref(false);
	const selectIndeterminate = ref(false);
	const selectIndeterminate_right = ref(false);
	const close_out : any = ref(null);
	const enter_change_flag : any = ref(false);
	const select_brand_value = ref('');//群体更改云机弹窗选中的品牌
	const select_model_value = ref(''); //群体更改云机弹窗选中的机型
	const select_model_list = ref<ModelOption[]>([]);
	const android_classify_phone_list = ref<AndroidVersionGroup[]>([]);
	const android_selectedPhones = ref<Phone[]>([]); //更换机型弹窗根据安卓版本选中的云手机列表数据
	const change_phone_model_visible : any = ref(false); //群体更改云手机机型弹窗开关
	const current_android_version : any = ref(null); //当前群体更改云机机型弹窗时当前的tabs安卓版本
	const phoneTableRef = ref<any>(null); //当前更改云机机型弹窗里table ref
	const current_android_phone_tableData : any = ref(false);
	const reset_phone_data_checked : any = ref(false);
	const warningMessage : any = ref(null);
	const ws : Ref<WebSocket | null> = ref(null);
	const StreamClientScrcpy_start : Ref<StreamClientScrcpy | null> = ref(null);
	const cascader_value = ref([]);
	const loading_phone_info : any = ref(null);
	const phone_type_list = ref<PhoneBrand[]>([]); // 现在使用定义好的 PhoneBrand 类型
	const phone_type_cascader_show = ref(false);
	const fetchPhoneList_Interval = ref<NodeJS.Timeout | null>(null)
	const IsEnglish_Or_Chinese_input = ref(true);
	const props = { label: 'model', value: 'id', children: 'models' };
	const selectedDevicesCountInCurrentType = computed(() => phoneList.value.filter(phone => phone.checked).length);
	const selectedDevicesCountInCurrentType2 = computed(() => previewPhoneList.value.filter(phone => phone.checked).length);
	const handleImageError = (e : any) => {
		const target = e.target as HTMLImageElement;
		target.src = defaultImage;
	};
	const filteredDevices = computed(() => phoneList.value);
	const toggleSelectAll = (val : boolean) => {
		phoneList.value.forEach(phone => {
			phone.checked = val;
			Phone_selectedMap.value.set(phone.id, val);
		});
		selectAllChecked.value = val;
		selectIndeterminate.value = false;
	};
	const toggleSelectAll_right = (val : boolean) => {
		previewPhoneList.value.forEach(phone => {
			phone.checked = val;
			Phone_selectedMap_right.value.set(phone.id, val);
		});
		selectIndeterminate_right.value = false;
		selectAllChecked_right.value = val;
	};

	watch(phoneList, (newVal) => {
		if (newVal.length === 0) {
			selectAllChecked.value = false;
			selectIndeterminate.value = false;
			return;
		}
		const checkedCount = newVal.filter(phone => phone.checked).length;
		selectAllChecked.value = checkedCount === newVal.length;
		selectIndeterminate.value = checkedCount > 0 && checkedCount < newVal.length;
	}, { deep: true });

	watch(previewPhoneList, (newVal) => {
		if (newVal.length === 0) {
			selectAllChecked_right.value = false;
			selectIndeterminate_right.value = false;
			return;
		}
		const checkedCount = newVal.filter(phone => phone.checked).length;
		selectAllChecked_right.value = checkedCount === newVal.length;
		selectIndeterminate_right.value = checkedCount > 0 && checkedCount < newVal.length;
	}, { deep: true });

	const Get_search_Phones = () => {
		phoneList.value = filteredPhones.value;
	};

	const filteredPhones = computed(() => {
		const searchTerm = search.value.toLowerCase();
		return No_change_phone_list.value.filter(phone => {
			const hasInstanceName = phone.instance_name && phone.instance_name.toLowerCase().includes(searchTerm);
			const hasInstancesName = phone.instances && phone.instances.name && phone.instances.name.toLowerCase().includes(searchTerm);
			return hasInstanceName || hasInstancesName;
		});
	});

	const selectedPhones = computed(() => phoneList.value.filter(phone => phone.checked));
	const showInfoToggle = computed(() => windowWidth.value < 800);

	const fetchPhoneList = async () => {
		try {
			loading.value = true;
			const response = await request.get<ApiResponse<Phone[]>>('/containers/list');
			if (response.data.code === 200) {
				No_change_phone_list.value = response.data.data.map(phone => ({
					...phone,
					checked: false,
					screen_shot_loading: phone.state == 0 ? true : false
				}));
				phoneList.value = filteredPhones.value;
				previewPhoneList.value = response.data.data.map(phone => ({
					...phone,
					checked: Phone_selectedMap_right.value.get(phone.id) ?? false,
					edit_name_checked: false,
					preview_image: phone.screen_shot.includes('http') ? phone.screen_shot + `?timestamp=${Date.now()}` : store.state.request_url + phone.screen_shot + `?timestamp=${Date.now()}`,
					screen_shot_loading: phone.state == 0 ? true : false
				}));
			} else {
				ElMessage.error(response.data.msg || '获取云手机列表失败');
			}
		} catch (error) { } finally {
			loading.value = false;
		}
	};
	//修改云机名称
	const edit_phone_name = async (phone_data : any) => {
		phone_data.edit_name_checked = !phone_data.edit_name_checked
		await nextTick();
		const inputSelector = `.phoneInput_${phone_data.id}`;
		const inputEl = document.querySelector<HTMLInputElement>(inputSelector);
		if (phone_data.edit_name_checked == false) {
			enter_edit_phone_name(phone_data, 'enter')
		} else {
			inputEl?.focus()
		}
	};
	//回车或者失焦修改名称
	const enter_edit_phone_name = (phone_data : any, type : any) => {
		if (type == 'enter') {
			enter_change_flag.value = true
		} else {
			if (enter_change_flag.value == true) {
				enter_change_flag.value = false
				return;
			} else {
				enter_change_flag.value = false
			}
		}
		if (phone_data.instance_name.length > 10) {
			ElMessage.warning('云机名称最多不能超过10个字符');
		} else {
			const requestData = { instance_use_id: phone_data.id, name: phone_data.instance_name };
			const response = request.post('/instance/rename', requestData);
			response.then((res) => {
				if (res.data.code == 200) {
					phone_data.edit_name_checked = false
					ElMessage.success('修改云机名称成功');
				}
			})
		}
	};
	const getRemainingDaysColor = (phone : any) : string => {
		// 修复点5：修正属性名（expire_time 而非 expireTime）
		const expireDate = new Date(phone.expire_time);
		const now = new Date();
		const diffTime = expireDate.getTime() - now.getTime();
		const days = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
		if (days <= 1) return 'red';
		if (days <= 3) return 'orange';
		return '#909399';
	};

	const formatDate = (dateString : string) : string => {
		if (!dateString) return '';
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return 'Invalid Date';
		return date.toLocaleString('zh-CN', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
			timeZone: 'Asia/Shanghai'
		}).replace(/\//g, '-');
	};

	const isSingleSelected = (phone : Phone) => selectedDevicesCountInCurrentType.value === 1 && phone.checked;

	const selectPhone = (phone : Phone) => {
		phone.checked = !phone.checked;
		Phone_selectedMap.value.set(phone.id, !phone.checked);
	};

	const selectPhone_right = (phone : Phone) => {
		phone.checked = !phone.checked;
		Phone_selectedMap_right.value.set(phone.id, !phone.checked);
	};
	const showPhoneOverlay = async (phone : any) => {
		await new Promise<void>((resolve) => {
			currentPhone.value = phone;
			resolve();
		});
		const index = previewPhoneList.value.findIndex(item => item.id === phone.id);
		if (phone.state == 0) {
			previewPhoneList.value[index].screen_shot_loading = true;
		} else if (phone.state == 1) {
			initPhone(phone, 800);
		} else {
			previewPhoneList.value[index].screen_shot_loading = false;
			ElMessage.error('该云手机目前处于离线状态');
		}
		showInfoPanel.value = windowWidth.value >= 800;
	};

	const isUserActive = ref(true);
	const hoverdada = () => {
		if (restartPhone_loading_text.value == '断流待机中' && restartPhone_loading.value) {
			close_out.value = null;
			restartPhone_loading.value = false;
			initPhone(currentPhone.value, 800);
		}
	};

	const handleActivityChange = (active : boolean) => {
		isUserActive.value = active;
		if (!active) {
			restartPhone_loading.value = true;
			restartPhone_loading_text.value = '断流待机中';
			closeOverlay(true);
		}
	};

	watch(() => store.state.Horizontal_screen, (newvalue) => {
		if (newvalue) {
			document.documentElement.style.setProperty('--zoomsize', '0.8');
		} else {
			document.documentElement.style.setProperty('--zoomsize', `${setCloudPhoneZoom()}`);
		}
	});

	const initPhone = (phone : any, time : any) => {
		if (!phone.instances.machine || !phone.instances.adb_port) {
			ElMessage.error('该云手机实例信息不完整');
			return;
		}
		const udid = `${phone.instances.machine.ip}:${phone.instances.adb_port}`;
		const wsUrl = `wss://${process.env.VUE_APP_API_WS_URL}?action=proxy-adb&remote=tcp:8886&udid=${udid}`;
		parsedQuery.set("action", "stream");
		parsedQuery.set("player", "mse");
		parsedQuery.set("udid", udid);
		parsedQuery.set("hostname", "ws.jtcloud.icu");
		parsedQuery.set("ws", wsUrl);
		parsedQuery.set("port", '10443');
		parsedQuery.set("secure", "true");
		StreamClientScrcpy_start.value = StreamClientScrcpy.start(parsedQuery, undefined, undefined, undefined, undefined, true, true);
		StreamClientScrcpy_start.value.setIdleThreshold(240000);
		StreamClientScrcpy_start.value.addActivityListener(handleActivityChange);
		const player = StreamClientScrcpy_start.value?.getPlayer();
		const checkbox = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`) as HTMLInputElement | null;
		if (checkbox) {
			checkbox.checked = false;
			checkbox.dispatchEvent(new Event('change'));
		}
		setTimeout(() => {
			if (store.state.Phone_Local_keyboard_flag) {
				const toggleBtn = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`);
				if (toggleBtn) {
					toggleBtn.dispatchEvent(new MouseEvent('click', {
						bubbles: true,
						cancelable: true
					}));
				}
			}
		}, 800);
		if (player) {
			setTimeout(() => {
				if (player.videoWidth > player.videoHeight) {
					store.commit('change_screen', true);
					document.documentElement.style.setProperty('--zoomsize', '0.8');
				} else {
					store.commit('change_screen', false);
					document.documentElement.style.setProperty('--zoomsize', `${setCloudPhoneZoom()}`);
				}
				showOverlay.value = true;
			}, time);
			player.touchableCanvas.onclick = () => {
				setTimeout(() => {
					if (!store.state.Horizontal_screen && player.videoWidth > player.videoHeight) {
						store.commit('change_screen', true);
					}
					if (store.state.Horizontal_screen && player.videoWidth < player.videoHeight) {
						store.commit('change_screen', false);
					}
				}, 1000);
			};
		} else {
			ElMessage.error('该云手机实例生成出错,不存在该云机实例');
		}
	};
	//关闭云手机渲染操作弹窗
	const closeOverlay = (flag : any) => {
		if (flag == false) {
			showOverlay.value = false;
			cascader_value.value = [];
		}
		if (ws.value) {
			if (ws.value.readyState === WebSocket.OPEN) {
				ws.value.close(1000, '正常关闭');
			}
			ws.value = null;
		}
		if (StreamClientScrcpy_start.value) {
			warningMessage.value?.close();
			StreamClientScrcpy_start.value.onDisconnected();
			StreamClientScrcpy_start.value.removeActivityListener(handleActivityChange);
			StreamClientScrcpy_start.value.destroy();
			StreamClientScrcpy_start.value = null;
			store.commit('change_screen', false);
		}
		clearImeEvents();
	};
	//单个云手机续费
	const renewPhone = (Phone : any) => {
		const skip_value = { deviceId: [Phone.id], is_realphone: Phone.instances.is_realphone, tab: 'second' };
		router.push('/purches/' + encodeURIComponent(JSON.stringify(skip_value)));
	};
	//批量续费云手机
	const batchRenew = () => {
		const selected = phoneList.value.filter(phone => phone.checked);
		if (selected.length === 0) {
			ElMessage.warning('请先选择云手机');
			return;
		}
		const skip_value = { deviceId: selected.map(phone => phone.id), is_realphone: phoneList.value[0].instances.is_realphone, tab: 'second' };
		router.push('/purches/' + encodeURIComponent(JSON.stringify(skip_value)));
	};
	//购买云手机(跳转云手机页面)
	const addNewPhone = () => {
		router.push('/purches/0');
	};
	//重启云手机
	const restartPhone = () => {
		const requestData = { instance_id: currentPhone.value.id };
		const response = request.post('/containers/restart', requestData);
		const response2 = request.post('/containers/info', requestData);
		restartPhone_loading.value = true;
		restartPhone_loading_text.value = '云手机重启中,请稍等';
		closeOverlay(true);
		response.then(() => {
			var loading_val = setInterval(() => {
				response2.then((res2) => {
					if (res2.data.data.status == 1) {
						clearInterval(loading_val);
						setTimeout(() => {
							initPhone(currentPhone.value, 1000);
							restartPhone_loading.value = false;
						}, 6000);
					}
				});
			}, 1000);
		});
	};

	const shutdownPhone = () => {
		ElMessageBox.confirm(
			'一键新机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		)
			.then(async () => {
				const requestData = { instance_use_id: currentPhone.value.id };
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重启中,请稍等';
				closeOverlay(true);
				await request.post('/realphone/easy_recreate', requestData);
				await new Promise(resolve => setTimeout(resolve, 5000));
				await pollContainerInfo(currentPhone.value.id, {
					interval: 5000,
					maxAttempts: 10,
					onProgress: (attempt) => { console.log(`第${attempt}次轮询`); }
				});
				setTimeout(() => {
					initPhone(currentPhone.value, 1000);
				}, 6000);
				restartPhone_loading.value = false;
			})
			.catch(() => { })
	};

	const restart_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			const requestData = { instance_use_ids: selected_data.map(item => item.id) };
			request.post('/containers/batch_restart', requestData).then(() => {
				ElMessage.success('云手机重启中');
				fetchPhoneList();
			}).catch(() => { });
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};

	const reset_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			ElMessageBox.confirm(
				'重置云机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					const requestData = { instance_use_ids: selected_data.map(item => item.id) };
					request.post('/containers/batch_reset', requestData).then(() => {
						ElMessage.success('云手机重启中');
						fetchPhoneList();
					}).catch(() => { });
				})
				.catch(() => { })
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};
	//群体一键新机
	const shutdown_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			ElMessageBox.confirm(
				'一键新机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					const requestData = { instance_use_ids: selected_data.map(item => item.id) };
					request.post('/realphone/batch_easy_recreate', requestData).then(() => {
						ElMessage.success('云手机重启中');
						fetchPhoneList();
					}).catch(() => { });
				})
				.catch(() => { })
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};
	//更换机型弹窗根据安卓版本选中的云手机列表
	const handleSelectionChange = (val : any[]) => {
		android_selectedPhones.value = val;
	};

	// 1. 添加 checkSelectable 方法
	const checkSelectable = (row : Phone) => {
		// 如果 instances.is_realphone 为 0，则禁用选择
		return row.instances?.is_realphone === 1;
	};

	const getRowClass = ({ row }: { row: Phone; rowIndex: number }) => {
		if (row?.instances?.is_realphone === 0) {
			return 'disabled-row';
		}
		return '';
	};

	const getCellClass = ({ row }: { row: Phone; rowIndex: number }) => {
		if (row?.instances?.is_realphone === 0) {
			return 'disabled-cell';
		}
		return '';
	};

	//群体更换机型弹窗开关
	const change_phone_model_dialog_show = async (item : AndroidVersionGroup) => {
		try {
			const res = await request.get(`/realphone/list?android_version=${item.android_version}`);
			res.data.data.forEach((item : any, index : number) => {
				res.data.data[index] = { ...item, model: item.brand, id: index };
			});
			phone_type_list.value = res.data.data;
			current_android_phone_tableData.value = item.phones_arr;
			current_android_version.value = item.android_version;

			// 等待 DOM 更新
			await nextTick();

			// 自动勾选 checked 为 true 且 is_realphone 为 1 的行
			if (phoneTableRef.value) {
				// 先清除所有选择
				phoneTableRef.value.clearSelection();

				// 只勾选 checked 为 true 且 is_realphone 为 1 的行
				current_android_phone_tableData.value.forEach((row : Phone) => {
					if (row.checked && row.instances?.is_realphone === 1) {
						phoneTableRef.value.toggleRowSelection(row, true);
					}
				});
			}

			// 最后再显示对话框
			change_phone_model_visible.value = true;
		} catch (error) {
			console.error('请求失败:', error);
		}
	};
	//把云手机列表按安卓版本进行分类处理
	const android_classify_phone = async () => {
		// 按安卓版本分组
		const groupedArray = previewPhoneList.value.reduce((result : any[], currentItem : any) => {
			const tag = currentItem.image_tag;
			let tagGroup = result.find((group : AndroidVersionGroup) => group.android_version === tag);

			if (!tagGroup) {
				tagGroup = {
					android_version: tag,
					phones_arr: []
				};
				result.push(tagGroup);
			}

			tagGroup.phones_arr.push(currentItem);
			return result;
		}, []);
		// 对分组进行排序：按安卓版本号（字符串转数字）
		groupedArray.sort((a : any, b : any) => {
			// 提取版本号数字，处理可能的小数点
			const versionA = parseFloat(a.android_version) || 0;
			const versionB = parseFloat(b.android_version) || 0;
			return versionB - versionA; // 降序排列（高版本在前）
		});
		// 对每个分组内的phones_arr进行排序：checked为true的在前
		groupedArray.forEach((group : any) => {
			group.phones_arr.sort((a : any, b : any) => {
				// 如果a.checked为true，b.checked为false，则a在前
				if (a.checked && !b.checked) return -1;
				// 如果a.checked为false，b.checked为true，则b在前
				if (!a.checked && b.checked) return 1;
				// 其他情况保持原顺序
				return 0;
			});
		});
		android_classify_phone_list.value = groupedArray;
		change_phone_model_dialog_show(android_classify_phone_list.value[0]);
	};
	// 添加一个安全的方法来处理 row-key
	const getRowKey = (row : Phone) => {
		if (!row) return 'empty-row-key';
		return row.instance_id || row.id || Math.random().toString();
	};
	//按照安卓品牌更换机型时 选择品牌
	const select_brands = (value : string) => {
		const foundItem = phone_type_list.value.find(item => item.brand === value);
		// 类型断言改为符合 ModelOption 类型
		select_model_list.value = (foundItem ? foundItem.models : []) as ModelOption[];
	}
	//群体更换机型方法
	const check_All_phone_type = async () => {
		if (!select_brand_value.value || !select_model_value.value) {
			ElMessage.warning('请先选择云机品牌和机型');
			return;
		}
		if (android_selectedPhones.value.length > 0) {
			const requestData = {
				model_id: select_model_value.value,
				instance_use_ids: android_selectedPhones.value.map(item => item.id),
				clear_data: reset_phone_data_checked.value ? 'true' : 'false'
			};
			restartPhone_loading.value = true;
			request.post('/realphone/batch_change_model', requestData).then(() => {
				ElMessage.success('云手机重启中');
				change_phone_model_visible.value = false
				fetchPhoneList();
			}).catch(() => { });
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};

	const pollRequest = async <T>(
		requestFn : () => Promise<any>,
		checkFn : (response : any) => boolean,
		options : { interval ?: number; maxAttempts ?: number; onProgress ?: (attempt : number, response : any) => void; } = {}
	) : Promise<T> => {
		const { interval = 5000, maxAttempts = 10, onProgress } = options;
		let attempts = 0;
		const poll = async () : Promise<T> => {
			attempts++;
			try {
				const response = await requestFn();
				if (onProgress) onProgress(attempts, response);
				if (checkFn(response)) return response;
				else if (attempts >= maxAttempts) throw new Error(`轮询达到最大次数 (${maxAttempts})`);
				else {
					await new Promise(resolve => setTimeout(resolve, interval));
					return poll();
				}
			} catch (error) {
				if (attempts >= maxAttempts) throw error;
				else {
					await new Promise(resolve => setTimeout(resolve, interval));
					return poll();
				}
			}
		};
		return poll();
	};

	const pollContainerInfo = (
		instanceId : number,
		options : { interval ?: number; maxAttempts ?: number; onProgress ?: (attempt : number, response : any) => void; } = {}
	) => {
		const requestFn = () => request.post('/containers/info', { instance_id: instanceId });
		const checkFn = (response : any) => response.data.data.state === 1;
		return pollRequest(requestFn, checkFn, options);
	};
	//单云机重置
	const resetPhone = () => {
		ElMessageBox.confirm(
			'重置云机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		)
			.then(() => {
				const requestData = { instance_id: currentPhone.value.id };
				const response = request.post('/containers/batch_reset', requestData);
				const response2 = request.post('/containers/info', requestData);
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重置并重启中,请稍等';
				closeOverlay(true);
				response.then(() => {
					var loading_val = setInterval(() => {
						response2.then((res2) => {
							if (res2.data.data.status == 1) {
								clearInterval(loading_val);
								setTimeout(() => {
									initPhone(currentPhone.value, 1000);
									restartPhone_loading.value = false;
								}, 6000);
							}
						});
					}, 1000);
				});
			})
			.catch(() => { })
	};

	const change_phone_type = (type : any) => {
		request.get(`/realphone/list?android_version=${currentPhone.value.image_tag}`).then((res) => {
			res.data.data.forEach((item : any, index : any) => {
				res.data.data[index] = { ...item, model: item.brand, id: index };
			});
			phone_type_list.value = res.data.data;
			phone_type_cascader_show.value = true
		});
	};

	const check_phone_type = async (value : any) => {
		var requestData = {
			model_id: value[value.length - 1],
			instance_use_id: currentPhone.value.id
		};
		restartPhone_loading.value = true;
		restartPhone_loading_text.value = '云手机重启中,请稍等';
		phone_type_popoverRef.value?.hide()
		closeOverlay(true);
		try {
			await request.post('/realphone/change_model', requestData);
			await new Promise(resolve => setTimeout(resolve, 5000));
			await pollContainerInfo(currentPhone.value.id, {
				interval: 5000,
				maxAttempts: 10
			});
			setTimeout(() => {
				initPhone(currentPhone.value, 1000);
			}, 6000);
			restartPhone_loading.value = false;
		} catch (error) {
			restartPhone_loading.value = false;
			phone_type_popoverRef.value?.hide()
			throw error;
		}
	};

	const polling_containers_info = () => {
		const containers_info = { instance_id: currentPhone.value.id };
		request.post('/containers/info', containers_info).then((res2) => {
			if (res2.data.data.status == 1) {
				clearInterval(loading_phone_info.value);
				setTimeout(() => {
					initPhone(currentPhone.value, 1000);
					restartPhone_loading.value = false;
				}, 5000);
			}
		});
	};

	const handleResize = () => {
		windowWidth.value = window.innerWidth;
		if (windowWidth.value >= 800 && !showInfoPanel.value) {
			showInfoPanel.value = true;
		}
		if (window.innerWidth < 800) {
			elementWidth.value = '100%';
			elementWidthflag.value = false;
		} else {
			elementWidth.value = 'auto';
			elementWidthflag.value = true;
		}
	};

	const initPlayers = async (zoomsize : any) => {
		const { MsePlayer } = await import('@/app/player/MsePlayer');
		StreamClientScrcpy.registerPlayer(MsePlayer);
		const { WebCodecsPlayer } = await import('@/app/player/WebCodecsPlayer');
		StreamClientScrcpy.registerPlayer(WebCodecsPlayer);
		MsePlayer.resize(880, 1920, zoomsize, 5388608);
	};
	//根据当前电脑分辨率计算出当前云手机屏幕的缩放比例
	function setCloudPhoneZoom() {
		var zoomsize = 0.4
		var screen_width = window.screen.width
		if (screen_width > 1920) {
			zoomsize = 0.4 + (Math.floor((screen_width - 1920) / 96) * 0.01)
		} else if (screen_width < 1920) {
			zoomsize = 0.4 - (Math.floor((1920 - screen_width) / 96) * 0.01)
		} else {
			zoomsize = 0.4
		}
		return zoomsize;
	}
	onMounted(async () => {
		const zoom = setCloudPhoneZoom();
		await initPlayers(zoom);
		window.addEventListener('resize', handleResize);
		fetchPhoneList();
	});

	onUnmounted(() => {
		if (StreamClientScrcpy_start.value) {
			StreamClientScrcpy_start.value.removeActivityListener(handleActivityChange);
			StreamClientScrcpy_start.value.destroy();
		}
		if (fetchPhoneList_Interval.value) {
			clearInterval(fetchPhoneList_Interval.value);
			fetchPhoneList_Interval.value = null;
		}
		window.removeEventListener('resize', handleResize);
		clearImeEvents();
	});

	const imeRef = ref<HTMLInputElement | null>(null);
	const imeRef2 = ref<HTMLInputElement | null>(null);
	let lastSent = "";
	let isEventsBound = false;
	let keyInputListener : KeyEventListener | null = null;
	let isComposing = ref(false);
	function sendMsg(msg : InputMsg) : void {
		const currentPhone_udid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = { udid: currentPhone_udid, text: msg.text };
		request.post('/containers/transfer_text', requestData).then(() => {
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
		}).catch(() => { });
	}
	const imeRef_focus = () => {
		if (store.state.Phone_Local_keyboard_flag) {
			imeRef.value?.focus()
		} else {
			imeRef2.value?.focus()
		}
	}
	const handleCompositionStart = (e : Event) => {
		const ev = e as CompositionEvent;
		isComposing.value = true;
		KeyInputHandler.setWebSocketEnabled(false);
		e.stopImmediatePropagation();
		e.preventDefault();
	};

	const handleCompositionEnd = (e : Event) => {
		const ev = e as CompositionEvent;
		const chineseText = ev.data?.trim();
		setTimeout(() => {
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}, 100);

		if (chineseText && store.state.Phone_Local_keyboard_flag && imeRef.value) {
			const msg : CommitMsg = { type: 'commit', text: chineseText };
			sendMsg(msg);
			imeRef.value.value = "";
			lastSent = "";
		}
	};

	const handleInput = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const inputEvent = e as InputEvent;
		const newValue = imeRef.value.value;

		if (isComposing.value) {
			return;
		}
		if (newValue.length > lastSent.length) {
			const newChars = newValue.slice(lastSent.length);

			for (const char of newChars) {
				if (char === '?' || char === '/') {
					sendSymbolAsText(char);
					continue;
				}
				if (char >= ' ' && char <= '~') {
					KeyInputHandler.sendCharacter(char);
					console.log('前端传递字符到 sendCharacter:', char);
				}
			}
			lastSent = newValue;
		}
		else if (newValue.length < lastSent.length) {
			lastSent = newValue;
		}
	};
	const sendSymbolAsText = (symbol : string) => {
		if (!currentPhone.value?.instances?.machine || !currentPhone.value?.instances?.adb_port) {
			ElMessage.error('云手机信息不完整，无法发送符号');
			return;
		}
		const currentPhoneUdid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = {
			udid: currentPhoneUdid,
			text: symbol
		};
		request.post('/containers/transfer_text', requestData)
			.then(() => { })
			.catch(() => { });
	};

	const handleKeyDown = (e : KeyboardEvent) => {
		if (!store.state.Phone_Local_keyboard_flag || isComposing.value) return;
		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'down', 0);
			return;
		}

		if (e.key === 'Backspace') {
			e.preventDefault();
			KeyInputHandler.sendBackspaceKey();
			return;
		}

		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'down', metaState);
		}
	};

	const handleKeyUp = (e : KeyboardEvent) => {
		if (isComposing.value || !store.state.Phone_Local_keyboard_flag) {
			e.stopPropagation();
			e.preventDefault();
			return;
		}

		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'up', 0);
			return;
		}

		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'up', metaState);
		}
	};
	const handlePaste = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText) {
			let pastedTexted : string = pastedText
			StreamClientScrcpy_start.value?.sendMessage(CommandControlMessage.createSetClipboardCommand(pastedTexted))
			imeRef.value.value = "";
		}
	};
	const handlePaste2 = (e : Event) => {
		if (store.state.Phone_Local_keyboard_flag || !imeRef2.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText != "" && pastedText != undefined) {
			let pastedTexted : string = pastedText
			StreamClientScrcpy_start.value?.sendMessage(CommandControlMessage.createSetClipboardCommand(pastedTexted))
		}
	};

	const handleFocus = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		lastSent = imeRef.value.value;
	};

	const handleBlur = (e : Event) => {
		isComposing.value = false;
		KeyInputHandler.setWebSocketEnabled(true);
	};
	const bindImeEvents = () => {
		const inp = imeRef.value;
		if (!inp || !store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('input', handleInput);
		inp.addEventListener('keydown', handleKeyDown);
		inp.addEventListener('compositionstart', handleCompositionStart);
		inp.addEventListener('compositionend', handleCompositionEnd);
		inp.addEventListener('keyup', handleKeyUp);
		inp.addEventListener('paste', handlePaste);
		inp.addEventListener('focus', handleFocus);
		inp.addEventListener('blur', handleBlur);
		keyInputListener = {
			onKeyEvent: (message) => {
				if (ws.value && ws.value.readyState === WebSocket.OPEN) {
					ws.value.send(JSON.stringify(message));
				}
			}
		};
		KeyInputHandler.addEventListener(keyInputListener);
		isEventsBound = true;
		inp.focus();
		setTimeout(() => inp.focus(), 100);
	};
	const bindImeEvents2 = () => {
		const inp = imeRef2.value;
		if (!inp || store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('paste', handlePaste2);
		setTimeout(() => inp.focus(), 100);
	};
	const clearImeEvents = () => {
		const inp = imeRef.value;
		if (!inp || !isEventsBound) return;
		inp.removeEventListener('keydown', handleKeyDown);
		inp.removeEventListener('input', handleInput);
		inp.removeEventListener('compositionstart', handleCompositionStart);
		inp.removeEventListener('compositionend', handleCompositionEnd);
		inp.removeEventListener('keyup', handleKeyUp);
		inp.removeEventListener('paste', handlePaste);
		inp.removeEventListener('focus', handleFocus);
		inp.removeEventListener('blur', handleBlur);
		if (keyInputListener) {
			KeyInputHandler.removeEventListener(keyInputListener);
			keyInputListener = null;
		}

		isEventsBound = false;
		isComposing.value = false;
		lastSent = "";
		inp.value = "";
	};

	const clearImeEvents2 = () => {
		const inp = imeRef2.value;
		if (!inp) return;

		inp.removeEventListener('paste', handlePaste);

		inp.value = "";
	};

	watch(() => showOverlay.value, (isShow) => {
		if (isShow && store.state.Phone_Local_keyboard_flag) {
			bindImeEvents();
			clearImeEvents2()
		} else {
			clearImeEvents();
			bindImeEvents2()
		}
	}, { immediate: true });

	watch(() => store.state.Phone_Local_keyboard_flag, (isEnabled) => {
		const inp = imeRef.value;
		if (!inp) return;
		if (isEnabled && showOverlay.value) {
			bindImeEvents();
			clearImeEvents2()
		} else {
			clearImeEvents()
			bindImeEvents2();
			inp.value = "";
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}
	}, { immediate: true });
	watch(() => store.state.orientation, (orientation) => {
		console.log('wahted orientation', orientation);
		if (StreamClientScrcpy_start.value) {
			StreamClientScrcpy_start.value.destroy();
			StreamClientScrcpy_start.value?.player?.stop()
			StreamClientScrcpy_start.value?.streamReceiver.destroy()
		}
		initPhone(currentPhone.value, 10)
	})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_cascader_panel = _resolveComponent("el-cascader-panel")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_row, {
    gutter: 10,
    style: {"background":"#f0f3f5","height":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 5,
        class: "left_box"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { style: {"border-right":"1px solid #ebeef5","height":"100%","background":"#ffffff"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: search.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "输入云手机名称或ID搜索",
                clearable: "",
                onInput: Get_search_Phones
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_checkbox, {
                  "model-value": selectAllChecked.value,
                  indeterminate: selectIndeterminate.value,
                  onChange: toggleSelectAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全选 (" + _toDisplayString(selectedDevicesCountInCurrentType.value) + "/" + _toDisplayString(phoneList.value.length) + ") ", 1)
                  ]),
                  _: 1
                }, 8, ["model-value", "indeterminate"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  disabled: selectedDevicesCountInCurrentType.value < 2,
                  onClick: batchRenew
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" 批量续费 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_el_scrollbar, { style: {"flex":"1","min-height":"0","padding-right":"15px"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneList.value, (phone) => {
                      return (_openBlock(), _createBlock(_component_el_card, {
                        key: phone.id,
                        shadow: "hover",
                        class: "mt-3",
                        style: {"position":"relative","min-height":"80px","padding":"10px","border-radius":"15px","cursor":"pointer"},
                        onClick: ($event: any) => (selectPhone(phone))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_el_checkbox, {
                                modelValue: phone.checked,
                                "onUpdate:modelValue": ($event: any) => ((phone.checked) = $event),
                                onClick: ($event: any) => (selectPhone(phone))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
                              _createElementVNode("div", _hoisted_5, _toDisplayString(phone.instance_name || `云机${phone.id}`), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "small",
                                disabled: selectedDevicesCountInCurrentType.value > 1 || (selectedDevicesCountInCurrentType.value === 1 && !phone.checked),
                                onClick: _withModifiers(($event: any) => (renewPhone(phone)), ["stop"])
                              }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("续费", -1)
                                ]))]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, "ID: " + _toDisplayString(phone.instances.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", {
                              style: _normalizeStyle({ color: getRemainingDaysColor(phone) })
                            }, [
                              _createVNode(CountdownComponent, {
                                expireTime: phone.expire_time,
                                is_trial: phone.is_trial
                              }, null, 8, ["expireTime", "is_trial"])
                            ], 4)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        span: 19,
        style: {"background":"#f0f3f5","padding":"0"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { style: {"border-left":"1px solid #ebeef5","height":"100%","background":"#ffffff"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_checkbox, {
                  "model-value": selectAllChecked_right.value,
                  indeterminate: selectIndeterminate_right.value,
                  onChange: toggleSelectAll_right
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全选 (" + _toDisplayString(selectedDevicesCountInCurrentType2.value) + "/" + _toDisplayString(phoneList.value.length) + ") ", 1)
                  ]),
                  _: 1
                }, 8, ["model-value", "indeterminate"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_popover, {
                    placement: "bottom",
                    trigger: "click",
                    "popper-style": "padding:0;"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "primary" }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("批量操作", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", { class: "fun_options" }, [
                        _createElementVNode("p", { onClick: restart_All_Phone }, "重启"),
                        _createElementVNode("p", { onClick: reset_All_Phone }, "重置"),
                        _createElementVNode("p", { onClick: shutdown_All_Phone }, "一键新机"),
                        _createElementVNode("p", { onClick: android_classify_phone }, "更换机型")
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(router).push('/groupControl')), ["stop"]))
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("云机群控", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_el_scrollbar, { height: "78vh" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { class: "main_container" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewPhoneList.value, (phone) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          key: phone.id,
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", {
                                  style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%","height":"20px"},
                                  onClick: _withModifiers(($event: any) => (selectPhone_right(phone)), ["stop"])
                                }, [
                                  _createVNode(_component_el_checkbox, {
                                    modelValue: phone.checked,
                                    "onUpdate:modelValue": ($event: any) => ((phone.checked) = $event),
                                    onClick: ($event: any) => (selectPhone_right(phone))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
                                  _createElementVNode("div", {
                                    class: "phone_name_box",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createVNode(_component_el_icon, {
                                      style: {"margin":"0 10px"},
                                      onClick: ($event: any) => (edit_phone_name(phone))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Edit))
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    (phone.edit_name_checked)
                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          "onUpdate:modelValue": ($event: any) => ((phone.instance_name) = $event),
                                          class: _normalizeClass(`phoneInput_${phone.id}`),
                                          onBlur: ($event: any) => (enter_edit_phone_name(phone,'blur')),
                                          onKeydown: _withKeys(($event: any) => (enter_edit_phone_name(phone,'enter')), ["enter"])
                                        }, null, 42, _hoisted_13)), [
                                          [_vModelText, phone.instance_name]
                                        ])
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_popover, {
                                      content: phone.instance_name,
                                      placement: "top",
                                      "popper-style": "padding:0;width:initial;min-width:initial;"
                                    }, {
                                      reference: _withCtx(() => [
                                        (!phone.edit_name_checked)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(phone.instance_name || `云机${phone.id}`), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["content"])
                                  ])
                                ], 8, _hoisted_12),
                                _withDirectives((_openBlock(), _createElementBlock("div", {
                                  class: "compact-image-container",
                                  "element-loading-text": "重启中,请稍等",
                                  "element-loading-background": "rgba(0, 0, 0, 0.5)",
                                  onClick: ($event: any) => (showPhoneOverlay(phone))
                                }, [
                                  (phone.preview_image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        style: {"max-width":"100%","max-height":"100%"},
                                        src: phone.preview_image,
                                        alt: "预览图",
                                        onError: handleImageError
                                      }, null, 40, _hoisted_16))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_17))
                                ], 8, _hoisted_15)), [
                                  [_directive_loading, phone.screen_shot_loading]
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", null, [
                                    _cache[16] || (_cache[16] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                                    _createTextVNode(_toDisplayString(phone.image_tag), 1)
                                  ]),
                                  _createElementVNode("div", null, _toDisplayString(phone.instances?.real_phone_template?.brand), 1)
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _createVNode(_component_el_col, { span: 2 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "compact-rectangle",
                            onClick: addNewPhone
                          }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_el_icon, { size: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CirclePlus))
                                  ]),
                                  _: 1
                                }),
                                _cache[17] || (_cache[17] = _createElementVNode("span", null, "新增云手机", -1))
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: change_phone_model_visible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((change_phone_model_visible).value = $event)),
        width: "500",
        title: "设备列表"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: check_All_phone_type
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode("更换机型", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (change_phone_model_visible.value = false))
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode("取消", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(android_classify_phone_list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["android-tab-item", { active: current_android_version.value == item.android_version }]),
                onClick: ($event: any) => (change_phone_model_dialog_show(item))
              }, "Android " + _toDisplayString(item.android_version), 11, _hoisted_22))
            }), 128))
          ]),
          _createVNode(_component_el_table, {
            ref_key: "phoneTableRef",
            ref: phoneTableRef,
            data: current_android_phone_tableData.value,
            style: {"width":"100%"},
            onSelectionChange: handleSelectionChange,
            "row-key": getRowKey,
            "row-class-name": getRowClass,
            "cell-class-name": getCellClass
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55",
                selectable: checkSelectable
              }),
              _createVNode(_component_el_table_column, {
                property: "instance_name",
                label: "云机名称"
              }),
              _createVNode(_component_el_table_column, {
                property: "instances.real_phone_template.brand",
                label: "品牌"
              }),
              _createVNode(_component_el_table_column, {
                property: "instances.real_phone_template.model",
                label: "机型"
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_23, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { style: {"white-space":"nowrap","margin-right":"10px"} }, "产品品牌", -1)),
            _createVNode(_component_el_select, {
              modelValue: select_brand_value.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((select_brand_value).value = $event)),
              placeholder: "请选择产品品牌",
              onChange: select_brands
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phone_type_list.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.brand,
                    label: item.brand,
                    value: item.brand
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _cache[19] || (_cache[19] = _createElementVNode("label", { style: {"white-space":"nowrap","margin":"0 10px"} }, "云机机型", -1)),
            _createVNode(_component_el_select, {
              modelValue: select_model_value.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((select_model_value).value = $event)),
              placeholder: "请选择云机机型",
              disabled: !select_brand_value.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(select_model_list.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.model,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_checkbox, {
              label: "重置云机数据",
              modelValue: reset_phone_data_checked.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((reset_phone_data_checked).value = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", {
              class: "overlay-container",
              style: _normalizeStyle({ width: elementWidth.value})
            }, [
              _createVNode(_component_el_icon, {
                class: "close-icon",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (closeOverlay(false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Close))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("input", {
                  id: "ime",
                  ref_key: "imeRef",
                  ref: imeRef,
                  style: {"position":"absolute","top":"0px","opacity":"0"},
                  readOnly: !_unref(store).state.Phone_Local_keyboard_flag
                }, null, 8, _hoisted_28),
                _createElementVNode("input", {
                  id: "ime2",
                  ref_key: "imeRef2",
                  ref: imeRef2,
                  style: {"position":"absolute","top":"0px","opacity":"0"},
                  readOnly: _unref(store).state.Phone_Local_keyboard_flag
                }, null, 8, _hoisted_29),
                (currentPhone.value.id)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "phone-display",
                      "element-loading-text": restartPhone_loading_text.value,
                      "element-loading-background": "rgba(0, 0, 0, 0.7)",
                      onMouseover: hoverdada
                    }, [
                      _createElementVNode("div", {
                        onClick: imeRef_focus,
                        id: `phone-display-${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`,
                        class: "master-phone-view",
                        style: {"padding-top":"15%"}
                      }, null, 8, _hoisted_31),
                      (showInfoToggle.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            class: "info-toggle-btn",
                            type: "primary",
                            circle: "",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (showInfoPanel.value = !showInfoPanel.value))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(showInfoPanel.value ? _unref(ArrowRight) : _unref(ArrowLeft))))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 40, _hoisted_30)), [
                      [_directive_loading, restartPhone_loading.value]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["phone-info", { 'hidden': !showInfoPanel.value }]),
                  style: _normalizeStyle({ display:elementWidthflag.value==true?'block':'none' })
                }, [
                  _cache[33] || (_cache[33] = _createElementVNode("h3", { style: {"margin-top":"0"} }, "云机详细信息", -1)),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "info-label" }, "云机名称", -1)),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(currentPhone.value.instance_name || `云机${currentPhone.value.id}`), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "info-label" }, "云机品牌机型", -1)),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(currentPhone.value.instances?.real_phone_template?.brand) + " " + _toDisplayString(currentPhone.value.instances?.real_phone_template?.model), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "info-label" }, "云机ID", -1)),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(currentPhone.value.instances?.name || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "info-label" }, "到期时间", -1)),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(formatDate(currentPhone.value.expire_time)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "info-label" }, "剩余天数", -1)),
                      _createElementVNode("span", _hoisted_42, [
                        _createVNode(CountdownComponent, {
                          expireTime: currentPhone.value.expire_time,
                          is_trial: currentPhone.value.is_trial
                        }, null, 8, ["expireTime", "is_trial"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "info-label" }, "运行状态", -1)),
                      _createElementVNode("span", _hoisted_44, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["status-tag", currentPhone.value.status === 1 ? 'running' : 'stopped'])
                        }, _toDisplayString(currentPhone.value.status === 1 ? '运行中' : '已停止'), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", { class: "info-label" }, "配置信息", -1)),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(currentPhone.value.instances?.cpu_cores || '-') + "核 " + _toDisplayString((currentPhone.value.instances?.memory / 1024).toFixed(0) || 0) + "G运存 " + _toDisplayString(currentPhone.value.instances?.storage || '-') + "G存储 ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_el_popover, {
                        ref_key: "phone_type_popoverRef",
                        ref: phone_type_popoverRef,
                        placement: "left",
                        trigger: "click",
                        width: "auto"
                      }, {
                        reference: _withCtx(() => [
                          (currentPhone.value.instances?.is_realphone==1)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                plain: "",
                                round: "",
                                type: "primary",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (change_phone_type('single')))
                              }, {
                                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                  _createTextVNode("更换机型", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_cascader_panel, {
                            modelValue: cascader_value.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((cascader_value).value = $event)),
                            options: phone_type_list.value,
                            props: props,
                            onChange: check_phone_type
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_el_button, {
                        plain: "",
                        round: "",
                        type: "warning",
                        onClick: restartPhone
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("重启", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        plain: "",
                        round: "",
                        type: "danger",
                        onClick: resetPhone
                      }, {
                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                          _createTextVNode("重置", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        plain: "",
                        round: "",
                        type: "success",
                        onClick: shutdownPhone
                      }, {
                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                          _createTextVNode("一键新机", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ], 6)
              ])
            ], 4)
          ], 512), [
            [_vShow, showOverlay.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})